import React from 'react';
import {Button, IconButton, Stack, Typography} from "@mui/material";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import AddIcon from '@mui/icons-material/Add';

export default function SourcePackageHeader(
    {
        breadcrumb,
        pathLength,
        onUp,
        onAddDocument,
        onAddFolder
    }) {
    return (
        <Stack p={2} py={1} alignItems={'center'} justifyContent={'space-between'}
               bgcolor={'white'}
               direction={'row'}>
            <Stack direction={'row'} alignItems={'center'} spacing={1}>
                {pathLength > 0 && (
                    <IconButton size="small" title="Up one level" onClick={onUp}>
                        <ArrowUpwardIcon fontSize="small"/>
                    </IconButton>
                )}
                <Typography variant="body1" fontWeight={600}>{breadcrumb}</Typography>
                <IconButton size="small" title="Add subfolder" onClick={onAddFolder}>
                    <AddIcon fontSize="small"/>
                </IconButton>
            </Stack>
            <Stack direction={'row'} spacing={1}>
                <Button
                    onClick={onAddDocument}
                    disabled={typeof onAddDocument !== 'function'}
                    sx={{
                        flexShrink: 0
                    }}
                >
                    Add Data
                </Button>
            </Stack>
        </Stack>
    );
}

